import { parseError, agent, updateSessionObject } from 'utils/api'
import { notify } from '../utils/notification'
import { formSubmitClear, formComplete } from 'actions/forms'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PERSONALINFO_RECEIVED_PERSONALINFO = 'PERSONALINFO_GET_PERSONALINFO'
export const PERSONALINFO_GETING_PERSONALINFO = 'PERSONALINFO_GETING_PERSONALINFO'
export const PERSONALINFO_UPDATING_PERSONALINFO = 'PERSONALINFO_UPDATING_PERSONALINFO'
export const PERSONALINFO_UPDATED_PERSONALINFO = 'PERSONALINFO_UPDATED_PERSONALINFO'
export const PERSONALINFO_ERROR = 'PERSONALINFO_ERROR'

export const PARTNERCHILDREN_GET = 'PARTNERCHILDREN_GET'
export const PARTNERCHILDREN_RECEIVED = 'PARTNERCHILDREN_RECEIVED'
export const PARTNERCHILDREN_GET_ERROR = 'PARTNERCHILDREN_GET_ERROR'
export const PARTNERCHILDREN_SET_SELECTED = 'PARTNERCHILDREN_SET_SELECTED'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const updating = type => ({
  type,
})

const updated = type => ({
  type,
})

const receive = (personalInfo, type) => ({
  type,
  personalInfo,
})

const partnerChildrenReceive = partnerchildrens => ({
  type: PARTNERCHILDREN_RECEIVED,
  partnerchildrens,
})

const selectedPartnerChildren = children => ({
  type: PARTNERCHILDREN_SET_SELECTED,
  children,
})

export function setSelectedPartnerChildren(selected) {
  return (dispatch) => {
    dispatch(selectedPartnerChildren(selected))
  }
}

export function getPersonalInfo(employeeId) {
  return (dispatch) => {
    dispatch(fetching(PERSONALINFO_GETING_PERSONALINFO))
    agent.PersonalInfo.details(employeeId)
      .then((resp) => {
        dispatch(receive(resp, PERSONALINFO_RECEIVED_PERSONALINFO))
      })
      .catch((rawError) => {
        console.error('Getting personal info error')
        // console.error('getPERSONALINFO error', rawError, rawError.stack, window.location)
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching personal info', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export function getPartnerChildrens(employeeId) {
  return (dispatch) => {
    dispatch(fetching(PARTNERCHILDREN_GET))
    agent.PartnerChildren.list(employeeId).then((response) => {
      dispatch(partnerChildrenReceive(response))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerChildrens>: ', description, error)
        dispatch(fetchingerror(PARTNERCHILDREN_GET_ERROR))
      }
    })
  }
}

export function editPersonalInfo(objPersonalInfo, formID) {
  return (dispatch) => {
    dispatch(updating(PERSONALINFO_UPDATING_PERSONALINFO))
    agent.PersonalInfo.update(objPersonalInfo).then((resp) => {
      dispatch(updated(PERSONALINFO_UPDATED_PERSONALINFO))
      dispatch(notify('Partner info successfully updated'))
      dispatch(getPersonalInfo(resp.employee_id))
      dispatch(getPartnerChildrens(resp.employee_id))
      dispatch(formComplete(formID))
    }).catch((errorPersonalInfo) => {
      const { error, status, errorMessage } = parseError(errorPersonalInfo)
      if (status === constants.ERROR.INTERNAL_SERVER) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(errorMessage))
        dispatch(notify('Error updating pesonalInfo, please try again later', 'warning'))
      }
      dispatch(formSubmitClear(formID))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/personalInfo.js